import {inject, Injectable} from '@angular/core';
import {ProjectControllerService, ProjectOfficeResponse} from '@frontend/shared';
import {firstValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ProjectOfficesProviderService {
  private readonly projectControllerService = inject(ProjectControllerService);

  private readonly officesByProjectId = new Map<number, ProjectOfficeResponse[]>();

  async getOffices(projectId: number): Promise<ProjectOfficeResponse[]> {
    const cached = this.officesByProjectId.get(projectId);
    if (cached) {
      return cached;
    }

    const projectResponse = await firstValueFrom(
      this.projectControllerService.getProjectDetails({id: projectId}),
    );

    const offices: ProjectOfficeResponse[] = Array.from(projectResponse.offices);
    this.officesByProjectId.set(projectId, offices);

    return offices;
  }
}
